import moment from 'moment';

export function getEventDate(record) {
    if(moment(record.endDate).format('DD-MMMM-YYYY') === moment(record.startDate).format('DD-MMMM-YYYY')) {
        return moment(record.startDate).format('DD MMMM YYYY')
    }
    return `${moment(record.startDate).format('DD MMMM')} till ${moment(record.endDate).format('DD MMMM YYYY')}` 
}

export function getMyRegistration(registrations, larperId) {
    if(registrations.length === 0) {
        return null;
    }

    // eslint-disable-next-line
    const found = registrations.filter(_ => _.larperId == larperId);
    return found[0];
}

export function getNPCCost(story, basecost) {

    if(story.includes("Stormvloed")) {
        return basecost - 5;
    }

    if(story.includes("Agnoia")) {
        return basecost - 10;
    }
    return basecost;
}

export function getRentCost(story) {
    if(story.includes("Zomerlarp")) {
        return 10;
    }
    return 5;
}

export function isSlOfEvent(story, appState) {
    if(appState.user?.userRoles?.length === 0) {
        return false;
    }

    const found = appState.user.userRoles.filter(_ => _.includes(story))
    return found.length > 0
}